import { palette } from '@app/src/theme/palette'
import { Stack, Typography, TypographyProps } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import DataFoundChart, { DataFoundChartBar } from './components/DataFoundChart'
import ParentCellOrFragment, { ParentCellOrFragmentProps } from './ParentCellOrFragment'

export type DataFoundCellProps = {
  dataFound: number
  link: string | { pathname: string; search?: string }
  disableCell?: boolean
  sx?: ParentCellOrFragmentProps['sx']
} & TypographyProps

const DataFoundCell: React.FC<DataFoundCellProps> = ({ dataFound, link, disableCell, sx, ...props }) => {
  const { formatMessage } = useIntl()

  const bars: DataFoundChartBar[] = [
    {
      name: formatMessage({ id: 'general.answered' }),
      link: link,
      color: palette.communication.dark,
      count: dataFound,
    },
    {
      name: formatMessage({ id: 'general.unanswered' }),
      link: link,
      color: palette.action.disabledBackground,
      count: 100 - dataFound,
    },
  ]

  if (dataFound === 0) {
    return (
      <ParentCellOrFragment disableCell={disableCell} sx={sx}>
        <Typography variant="body2" color="action.disabled" fontSize="1.75rem">
          {formatMessage({ id: 'general.noPublicDataFound' })}
        </Typography>
      </ParentCellOrFragment>
    )
  }

  return (
    <ParentCellOrFragment disableCell={disableCell} sx={sx}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <DataFoundChart bars={bars} />
        <Typography
          variant="body2"
          fontSize="1.75rem"
          flexGrow={1}
          component="span"
          data-testid="data-found-value"
          sx={{
            ml: '1px',
          }}
          {...props}
        >
          {`${dataFound} %`}
        </Typography>
      </Stack>
    </ParentCellOrFragment>
  )
}

export default DataFoundCell
